import { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import AuditLog from './AuditLog'
import AuditLogDetailsModal from 'pages/Admin/Modals/AuditLogDetailsModal'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, SubTitle, LabelRow } from './styles'

export default function AuditLogList ({
  auditLogs = [],
  hasMore,
  totalAuditLogs,
  onScroll: handleScroll
}) {
  const [selectedLog, setSelectedLog] = useState (null)
  const [showDetails, setShowDetails] = useState (false)

  const handleSelect = log => {
    setSelectedLog (log)
    setShowDetails (true)
  }

  return (
    <Container>
      <SubTitle style={{ marginBottom: 10 }}>
        {totalAuditLogs + ' ' + (totalAuditLogs === 1 ? 'Registro' : 'Registros')}
      </SubTitle>
      <InfiniteScroll
        dataLength={auditLogs.length}
        next={handleScroll}
        hasMore={hasMore}
        loader={<Loading/>}
        endMessage={<div style={{ height: 50 }}></div>}
        style={{ overflow: 'visible' }}
      >
        <LabelRow>
          <SubTitle>Data/Hora</SubTitle>
          <SubTitle>Autor</SubTitle>
          <SubTitle>Item</SubTitle>
          <SubTitle>Ação</SubTitle>
        </LabelRow>
        {auditLogs.map ((auditLog, index) => (
          <AuditLog key={index} data={auditLog} onSelect={handleSelect}/>
        ))}
      </InfiniteScroll>
      <AuditLogDetailsModal
        visible={showDetails}
        auditLog={selectedLog}
        onClose={() => {
          setShowDetails (false)
          setSelectedLog (null)
        }}
      />
    </Container>
  )
}
